import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="icons-warning_svg__a"
        d="M21.8 19.102L13.806 3.114a2.002 2.002 0 00-2.698-.899c-.3.2-.6.5-.8.9L2.216 19.101c-.5 1-.1 2.199.9 2.698.3.1.599.2.899.2h15.988A2.003 2.003 0 0022 20.002c0-.3-.1-.6-.2-.9zm-17.786.9l7.994-15.988 7.994 15.988H4.014zm6.994-9.993h1.999v4.996h-1.999V10.01zm0 5.996h1.999v1.998h-1.999v-1.998z"
      />
    </defs>
    <use
      fill="currentColor"
      fillRule="evenodd"
      xlinkHref="#icons-warning_svg__a"
    />
  </svg>
);
